module.exports = __webpack_public_path__ + "static/media/logo-alcaldia.bacf6923.png";